export const HideCheckboxOptions = {
    'OBxFnJ88xFR': {'field': ['u9b1KLuV3sD'], 'value': true},
    'uQ250w1cBt0': {'field': ['u9b1KLuV3sD'], 'value': true},
    'xBS7s8SdHK1': {'field': ['u9b1KLuV3sD'], 'value': true},
    'YkvrlyA8els': {'field': ['u9b1KLuV3sD'], 'value': true}
}   